import React from 'react';
import PropTypes from 'prop-types';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';
import { FooterDisclosureWrapper } from '@paypalcorp/pp-com-components/components/FooterDisclosureWrapper';

export function QuantumLeapFooter({ belowFooter, footerTheme, skipFooter }) {
  if (skipFooter) {
    return null;
  }

  return (
    <div className="document-footer">
      <NavFragment type="footer">
        {belowFooter
          ? (
            <NavFragment.After>
              <FooterDisclosureWrapper theme={footerTheme}>
                {
                  /** Fragment is required because `belowFooter` can be `[<Suspense />]`.
                   * Without the Fragment, it fails the `isValidFragment` check in the
                   * FooterDisclosureWrapper component.
                   * */
                }
                {/* eslint-disable-next-line react/jsx-no-useless-fragment */ }
                <>
                  {belowFooter}
                </>
              </FooterDisclosureWrapper>
            </NavFragment.After>
          ) : null}
      </NavFragment>
    </div>
  );
}

QuantumLeapFooter.propTypes = {
  belowFooter: PropTypes.node,
  footerTheme: PropTypes.string,
  skipFooter: PropTypes.bool,
};

QuantumLeapFooter.defaultProps = {
  belowFooter: null,
  footerTheme: "primary",
  skipFooter: false,
};
